import { Checkbox, Select } from "antd";
import React, { useEffect, useState } from "react";
import rpmService from "../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRpmPatientClinicalStatus,
  setSelectedRpmPatient,
} from "../../../../../Redux/actions/rpmActions";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
const options = [
  { value: 0, label: "Not Allocated" },
  { value: 1, label: "In Progress" },
  { value: 2, label: "Completed" },
];

function Index() {
  const [selectedReviewOption, setSelectedReviewOption] = useState("");
  const [reviewChecked, setReviewChecked] = useState(false);
  const [clinicalStatusFetched, setClinicalStatusFetched] = useState(false);
  const { selectedRpmPatient, clinicalStatus } = useSelector(
    (state) => state.rpm
  );
  const dispatch = useDispatch();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = localStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  useEffect(() => {
    if (selectedRpmPatient?.patientId) {
      const payload = {
        patientCode: selectedRpmPatient.patientId,
        status: 1,
      };
      dispatch(fetchRpmPatientClinicalStatus(payload));
    }
  }, [selectedRpmPatient]);

  useEffect(() => {
    if (clinicalStatus?.patientCode) {
      setReviewChecked(clinicalStatus.reviewedStatus === 1);
      if (clinicalStatus.processStatus >= 0) {
        setSelectedReviewOption(clinicalStatus.processStatus);
      }
      setClinicalStatusFetched(true);
    }
  }, [clinicalStatus]);

  // useEffect(() => {
  //     if (!selectedRpmPatient?.patientId || !clinicalStatusFetched) return;

  //     const statusChanged = selectedReviewOption !== clinicalStatus.processStatus;
  //     const reviewedChanged = (reviewChecked ? 1 : 0) !== clinicalStatus.reviewedStatus;

  //     if (statusChanged || reviewedChanged) {
  //         const payload = {};
  //         if (statusChanged) payload.processStatus = selectedReviewOption;
  //         if (reviewedChanged) payload.reviewedStatus = reviewChecked ? 1 : 0;

  //         handleUpdateClinicalStatus(payload);
  //     }
  // }, [reviewChecked, selectedReviewOption, clinicalStatusFetched]);

  const handleUpdateClinicalStatus = async (filterValues, actionType) => {
    if (clinicalStatus && clinicalStatus.length !== 0) {
      const payload = {
        ...clinicalStatus,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        fromClinicalStatus: 0,
        patientCode: selectedRpmPatient.patientId,
        status: 1,
      };

      if (filterValues) {
        if (actionType === "reviewCheck")
          payload.reviewedStatus = Number(filterValues.reviewedStatus);
        if (actionType === "reviewSelect")
          payload.processStatus = Number(filterValues.processStatus);
      }

      try {
        await rpmService.updatePatientClinicalStatus(payload);
      } catch (e) {
        console.error(e);
      }
    } else {
      const payload = {
        clinicalStatus: 0,
        createdBy: loggedUser?.user?.userId,
        modifiedBy: loggedUser?.user?.userId,
        createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        fromClinicalStatus: 0,
        patientCode: selectedRpmPatient.patientId,
        processStatus: selectedReviewOption
          ? selectedReviewOption
          : filterValues?.processStatus,
        reviewedStatus: reviewChecked ? 1 : 0,
        status: 1,
      };

      try {
        await rpmService.savePatientClinicalStatus(payload);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleCheck = (e) => {
    setReviewChecked(e.target.checked);
    const value = e.target.checked;
    const payload = { reviewedStatus: value === true ? "1" : "0" };
    handleUpdateClinicalStatus(payload, "reviewCheck");
  };

  const handleSelectChange = (value) => {
    setSelectedReviewOption(value);
    const payload = { processStatus: value };
    handleUpdateClinicalStatus(payload, "reviewSelect");
  };

  return (
    <div>
      <div className="relative h-full">
        <div className="text-black text-base font-sans font-semibold pb-2">
          Review:
        </div>
        <Select
          placeholder="Select"
          style={{ width: "100%" }}
          value={selectedReviewOption}
          onChange={handleSelectChange}
          options={options.map((item, idx) => {
            return {
              label: item.label,
              value: item.value,
              key: item.value,
            };
          })}
        />
        <div className="flex items-center font-medium font-inter mt-3">
          <Checkbox checked={reviewChecked} onChange={handleCheck}>
            Reviewed
          </Checkbox>
        </div>
      </div>
    </div>
  );
}

export default Index;
